import $ from 'jquery';
import _ from 'lodash';
import { View } from 'backbone';
import listService from '../../service/ListService';

class BasePropertyTabView extends View {

    initialize( opts ) {

        this.propertyViews = [];
    }

    clearPropertyViews() {
        let pViews = this.propertyViews;
        if (pViews) {
            _.forEach(pViews, function(v) {
                v.remove();
                v.unbind();
            });
            this.propertyViews = [];
        }
    }

    renderPropertyViews(views, model) {
      
        if (views) {
          
            views.forEach((v, index) => {

                if(index + 1 === views.length){
                    listService.loadProperties = true;
                }
                
                var obj = new v.view({model: model, el: $(v.el), config: v.config});
                obj.render();

                // store the view so we can access later
                this.propertyViews.push(obj);
            });
        }
    }

    close (){
        this.clearPropertyViews();
        super.remove();
        this.unbind();
        if (this.onClose){
            this.onClose();
        }
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
    }
}

export default BasePropertyTabView;